import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Store/Reducers/UserReducer";
import { useContextMenu } from "../../Layout Component/ContextMenu";
import Folliculogram from "./Folliculogram";
import DicomViewer from "./DicomViewer";

// A treatment cycle, opened from the overview or the treatment list, to LOOK
// at: the folliculogram and the digital images, nothing to edit. (The older
// Details page, TreatmentOutcome, is still there from the "Details" link; it
// is where the patient records a pregnancy outcome.)

const dayText = (raw) => {
  if (!raw || String(raw).startsWith("0001-01-01")) return null;
  const m = moment(raw);
  return m.isValid() && m.year() > 1 ? m.format("DD-MMM-YYYY") : null;
};

export default function TreatmentCycleView() {
  const url = process.env.REACT_APP_OXAR_API_URL;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { show, menu } = useContextMenu();

  const id = state?.id || localStorage.getItem("Tretmentid");
  const [tab, setTab] = useState(state?.tab === "images" ? "images" : "folliculogram");
  const [cycle, setCycle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;
    let alive = true;
    (async () => {
      try {
        dispatch(setLoader(true));
        const res = await axios(`${url}api/Treatment/GetTreatmentCycleById?id=${id}`);
        if (!alive) return;
        setCycle(res.data?.content || null);
        // The images are found by the cycle's name.
        const name = state?.name || res.data?.content?.name || "";
        sessionStorage.setItem("Treatmentid", id);
        sessionStorage.setItem("TreatmentName", name);
        localStorage.setItem("Tretmentid", id);
      } catch {
        if (alive) setError("This treatment could not be loaded. Please go back and try again.");
      } finally {
        dispatch(setLoader(false));
      }
    })();
    return () => { alive = false; };
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const title = state?.title || cycle?.name || "Treatment";
  const type = cycle?.bcrm_treatment_type_os_name;
  const start = dayText(cycle?.bcrm_treatment_start_date || cycle?.treatmentStartDate);

  return (
    <div
      className="ox-cycle"
      onContextMenu={(e) => show(e, [
        { label: "Folliculogram", onClick: () => setTab("folliculogram") },
        { label: "Images", onClick: () => setTab("images") },
        { divider: true },
        { label: "Back to my treatments", onClick: () => navigate("/Treatments") },
      ])}
    >
      <div className="ox-strip">
        <strong>{title}</strong>
        {state?.couple && <span className="ox-muted">{state.couple}</span>}
        {(state?.type || type) && <span className="ox-chip ox-chip--ok">{state?.type || type}</span>}
        {(state?.start || start) && <span className="ox-muted">Start {state?.start || start}</span>}
        {state?.range && <span className="ox-muted">Folliculogram {state.range}</span>}
        <span className="ox-chip ox-chip--viewing" style={{ marginLeft: "auto" }}>Read only</span>
        <button type="button" className="ox-btn" onClick={() => navigate(-1)}>Back</button>
      </div>

      {error && <p className="ox-hint" role="alert">{error}</p>}

      <div className="ox-tabs" role="tablist">
        {[["folliculogram", "Folliculogram"], ["images", "Images"]].map(([key, label]) => (
          <button key={key} type="button" role="tab" aria-selected={tab === key}
            className={`ox-tab${tab === key ? " is-active" : ""}`} onClick={() => setTab(key)}>
            {label}
          </button>
        ))}
      </div>

      <div className="ox-section">
        <div className="ox-section__body">
          {tab === "folliculogram" ? (
            cycle ? <Folliculogram json={cycle.folliculagramJSON} /> : !error && <p className="ox-hint">Loading...</p>
          ) : (
            // Mounted once the cycle is known: the viewer finds the images by
            // the cycle name stored above.
            cycle ? <DicomViewer /> : !error && <p className="ox-hint">Loading...</p>
          )}
        </div>
      </div>
      {menu}
    </div>
  );
}
